import {
  faCaretLeft,
  faCaretRight,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print-advanced";
import { getPatients } from "../../actions/patientAction";
import {
  clearHistorydPrescription,
  getHistoryPrescriptionForPractitioner,
  getUnfinalizedPrescription,
  practitonerPrescriptionPostAction,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import { constructDisplayText, getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
const PractitionerPrescriptionDetailPopup = ({
  closePopup,
  prescriptionId,
  isRefill,
  date,
  isOrdered,
  setIsOrdered,
  isSentToPatient,
}) => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const [singleHerbs, setSingleHerb] = useState([]);
  const [formulaHerbs, setFormulaHerb] = useState([]);
  const [practitionerView, setPractitionerView] = useState(true);
  const [orderedPrescription, setOrderedPrescription] = useState([]);
  const [singleHerbTotal, setSingleHerbTotal] = useState(0);
  const [perPacket, setPerPacket] = useState(0);
  const [selectedPatient, setSelectedPatient] = useState(0);
  const [loading, setLoading] = useState(true);
  const activeOrderedPrescription = useSelector(
    (state) => state.prescription.practitionerHistoryPresctionDetail
  );

  const practitionerUnfinalizedPrescriptionDetail = useSelector(
    (state) => state.prescription.practitionerUnfinalizedPrescriptionDetail
  );
  const patientList = useSelector((state) => state.patient.patientList);
  const appLoading = useSelector((state) => state.alert.appLoading);
  useEffect(() => {
    if (isRefill) {
      dispatch(
        getUnfinalizedPrescription(prescriptionId, () => {
          setLoading(false);
        })
      );
    } else {
      dispatch(
        getHistoryPrescriptionForPractitioner(prescriptionId, () => {
          setLoading(false);
        })
      );
    }
    return () => {
      if (setIsOrdered) {
        setIsOrdered(true);
      }
      dispatch(clearHistorydPrescription());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isRefill) {
      setOrderedPrescription(practitionerUnfinalizedPrescriptionDetail);
    } else {
      setOrderedPrescription(activeOrderedPrescription);
    }
  }, [activeOrderedPrescription, practitionerUnfinalizedPrescriptionDetail]);

  const getDosage = (dosage) => {
    let value = parseFloat(dosage);
    let roundedValue =
      orderedPrescription[0]?.Dosage_Type === 0
        ? value / parseFloat(orderedPrescription[0]?.Serving_Total)
        : value;
    return Math.round(roundedValue * 100) / 100;
  };

  const denyPrescription = () => {
    const data = {
      action: "cancelPrescription",
      prescription_id: prescriptionId,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(
      practitonerPrescriptionPostAction(params, () => {
        closePopup();
      })
    );
  };
  useEffect(() => {
    dispatch(getPatients());
  }, [dispatch]);
  const getPatientOptions = () => {
    let options = patientList.map((x) => {
      return (
        <option key={x.ID} value={x.ID}>
          {`${x.First_Name} ${x.Last_Name}`}
        </option>
      );
    });
    return options;
  };

  const handleAssign = () => {
    const data = {
      action: "addPatientToPrescription",
      prescription_id: prescriptionId,
      ppc_id: selectedPatient,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(
      practitonerPrescriptionPostAction(params, () => {
        let patient = patientList.find((x) => x.ID === selectedPatient);
        let newOrderedPrescription = orderedPrescription;
        newOrderedPrescription[0].Patient_Name = `${patient.First_Name} ${patient.Last_Name}`;
        setOrderedPrescription(newOrderedPrescription);
      })
    );
  };
  const rePrescribe = () => {
    if (isRefill) {
      let actionName = "represcribe";
      const data = {
        action: actionName,
        prescription_id: prescriptionId,
        token: getUserDetail()?.token,
      };
      var params = {
        params: data,
      };
      dispatch(
        practitonerPrescriptionPostAction(params, () => {
          dispatch(setUnfinalizedPrescriptionId(prescriptionId));
          dispatch(prescriptionPageTabShowItemList([3]));
          closePopup();
          history.push("/app/prescription");
        })
      );
    } else {
      const data = {
        action: "copyPrescription",
        prescription_id: prescriptionId,
        token: getUserDetail()?.token,
      };
      let params = {
        params: data,
      };
      dispatch(
        practitonerPrescriptionPostAction(params, (id) => {
          const data = {
            action: "represcribe",
            prescription_id: id,
            token: getUserDetail()?.token,
          };
          let params = {
            params: data,
          };
          dispatch(setUnfinalizedPrescriptionId(id));
          dispatch(prescriptionPageTabShowItemList([3]));
          dispatch(
            practitonerPrescriptionPostAction(params, () => {
              closePopup();
              history.push("/app/prescription");
            })
          );
        })
      );
    }
  };

  useEffect(() => {
    if (orderedPrescription?.length > 0) {
      let singleHerbItems = [];
      let formulaHerbItems = [];
      let formulaTableData = [];
      var perPacket = 0;
      orderedPrescription[1]?.forEach((x) => {
        if (x.form_display) {
          formulaHerbItems.push(x);
        } else {
          singleHerbItems.push(x);
        }
        perPacket += getDosage(x.dosage);
      });
      setPerPacket(perPacket);
      var totalValue = 0;
      singleHerbItems.forEach((x) => {
        totalValue += getDosage(x.dosage);
      });
      setSingleHerbTotal(totalValue);
      var formulaId = 0;

      for (let i = 0; i < formulaHerbItems.length; i++) {
        if (formulaId !== formulaHerbItems[i].form_id) {
          formulaId = formulaHerbItems[i].form_id;
          formulaTableData.push(
            <>
              <tr
                className="herb-title"
                key={formulaHerbItems[i].herb_id + "title"}
              >
                <td>{formulaHerbItems[i].form_display}</td>
              </tr>
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  <p
                    style={{ marginBottom: 0 }}
                    className={`${
                      formulaHerbItems[i].herb_id == 0
                        ? "sunten-formula-fix"
                        : ""
                    }`}
                  >
                    {getDosage(formulaHerbItems[i].dosage)?.toLocaleString(
                      "en-US",
                      {
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1,
                      }
                    )}
                  </p>
                </td>
              </tr>
            </>
          );
        } else {
          if (formulaId !== formulaHerbItems[i + 1]?.form_id) {
            formulaTableData.push(
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  +{" "}
                  {getDosage(formulaHerbItems[i].dosage).toLocaleString(
                    "en-US",
                    {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    }
                  )}
                </td>
              </tr>
            );
          } else {
            formulaTableData.push(
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  {getDosage(formulaHerbItems[i].dosage).toLocaleString(
                    "en-US",
                    {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    }
                  )}
                </td>
              </tr>
            );
          }

          if (formulaId !== formulaHerbItems[i + 1]?.form_id) {
            formulaTableData.push(
              <>
                <tr key={formulaHerbItems[i].herb_id + "title"}>
                  <td className="total-practitioner">Formula Total:</td>
                  <td className="d-flex justify-content-end">
                    <p className="hr-replacement">
                      {formulaHerbItems
                        .filter((y) => y.form_id === formulaId)
                        .map((x) => getDosage(x.dosage))
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("en-US", {
                          maximumFractionDigits: 1,
                          minimumFractionDigits: 1,
                        })}
                    </p>
                  </td>
                </tr>
              </>
            );
          }
        }
      }
      setSingleHerb(singleHerbItems);
      setFormulaHerb(formulaTableData);
    }
  }, [orderedPrescription]);

  return (
    <>
      {!loading ? (
        <Modal size="xl" show={true} id="prescription-popup">
          <Modal.Body>
            <>
              <div className="prescription-detail">
                <div className="close-btn">
                  <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
                </div>
                {orderedPrescription && (
                  <>
                    <div className="inner-section">
                      <div className="row">
                        <div className="col-md-6">
                          <h2 className="heading">Prescription</h2>
                          <p className="desc">
                            You can represcribe or print using the buttons at
                            the bottom or click on the slider to see the
                            patient's view.
                          </p>
                        </div>
                        <div className="col-md-6 switch">
                          <div
                            className={`swipe_content ${
                              practitionerView ? "left" : "right"
                            }`}
                          >
                            <button
                              type="button"
                              className="full_space"
                              onClick={() =>
                                setPractitionerView(!practitionerView)
                              }
                            ></button>
                            <div className="titles">
                              <span>PRACTITIONER</span>``
                              <span>PATIENT</span>
                            </div>
                            <div className="buttons">
                              <div className="button">
                                <FontAwesomeIcon icon={faCaretLeft} />
                                VIEW
                                <FontAwesomeIcon icon={faCaretRight} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="item-section" ref={componentRef}>
                        <div className="row">
                          <div className="col-md-8">
                            <div className="row">
                              <div className="col-md-6 reduce-height">
                                <h5>Practitioner:</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>
                                  {getUserDetail()?.firstName}{" "}
                                  {getUserDetail()?.lastName}
                                </p>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <h5>Patient:</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>{orderedPrescription[0]?.Patient_Name}</p>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <h5>Prescription #</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>{orderedPrescription[0]?.Prescription_ID}</p>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <h5>Date:</h5>
                              </div>
                              <div className="col-md-6 reduce-height">
                                <p>{date}</p>
                              </div>
                            </div>
                            {practitionerView && (
                              <div className="row mt-2">
                                <div className="col-md-6 reduce-height">
                                  <h5>Disease:</h5>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <p>{orderedPrescription[0]?.DC_Custom}</p>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <h5>Pattern:</h5>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <p>{orderedPrescription[0]?.DSC_Custom}</p>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <h5>Formula(s)</h5>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <p>{orderedPrescription[0]?.FORM_Custom}</p>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <h5>Mod(s):</h5>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <p>{orderedPrescription[0]?.MOD_Custom}</p>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <h5>Dosage Type:</h5>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <p>
                                    {orderedPrescription[0]?.Dosage_Type === 0
                                      ? "Raw"
                                      : "Granular"}
                                  </p>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <h5>PREPARATION METHOD:</h5>
                                </div>
                                <div className="col-md-6 reduce-height">
                                  <p>
                                    {orderedPrescription[0]
                                      ?.prep_method_label ||
                                      orderedPrescription[0]?.Prep_Method_Name}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 icon">
                            <img src={RxIcon} alt="icon" />
                          </div>
                        </div>
                        <div className="formula-table mt-4">
                          <table className="table table_review">
                            <thead>
                              <tr>
                                <th>FORMULA(S) &amp; HERB(S)</th>
                                <th className="text-right">DOSAGE</th>
                                {isOrdered && practitionerView && (
                                  <th className="text-right">PRICE</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {formulaHerbs.length > 0 && formulaHerbs}
                              {singleHerbs.length > 0 && (
                                <>
                                  <tr className="herb-title">
                                    <td>Single Herbs</td>
                                  </tr>
                                  {singleHerbs.map((x) => {
                                    return (
                                      <tr key={x.herb_id}>
                                        <td>
                                          {constructDisplayText(
                                            x.herb_display,
                                            x.HERB_Latin_Name,
                                            x.HERB_Chinese_Name,
                                            x.INV_ID_Granular
                                          )}
                                        </td>
                                        <td className="text-right">
                                          {getDosage(x.dosage).toLocaleString(
                                            "en-US",
                                            {
                                              maximumFractionDigits: 1,
                                              minimumFractionDigits: 1,
                                            }
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}

                                  <tr>
                                    <td className="total-practitioner">
                                      Single Herbs Total:
                                    </td>
                                    <td className="d-flex justify-content-end">
                                      <p className="hr-replacement">
                                        {singleHerbTotal.toLocaleString(
                                          "en-US",
                                          {
                                            maximumFractionDigits: 1,
                                            minimumFractionDigits: 1,
                                          }
                                        )}
                                      </p>
                                    </td>
                                  </tr>
                                </>
                              )}
                              {!isRefill && (
                                <>
                                  {orderedPrescription[0]?.Dosage_Type ===
                                    0 && (
                                    <>
                                      <tr>
                                        <td className="total-practitioner">
                                          Per Packet:
                                        </td>
                                        <td className="text-right">
                                          {perPacket.toLocaleString("en-US", {
                                            maximumFractionDigits: 1,
                                            minimumFractionDigits: 1,
                                          })}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="total-practitioner">
                                          Number of Packets:
                                        </td>

                                        <td className="text-right">
                                          x{" "}
                                          {
                                            orderedPrescription[0]
                                              ?.Serving_Total
                                          }
                                        </td>
                                      </tr>
                                    </>
                                  )}

                                  {isOrdered && practitionerView && (
                                    <>
                                      <tr className="line">
                                        <td></td>

                                        <td className="text-right">
                                          <div className="d-flex justify-content-end">
                                            <hr />
                                          </div>
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="total-practitioner">
                                          Subtotal:
                                        </td>
                                        <td></td>
                                        <td className="d-flex justify-content-end">
                                          <p className="hr-replacement">
                                            {(
                                              orderedPrescription[0]
                                                ?.Base_Price / 100
                                            ).toLocaleString("en-US", {
                                              maximumFractionDigits: 2,
                                              minimumFractionDigits: 2,
                                              style: "currency",
                                              currency: "USD",
                                            })}
                                          </p>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="total-practitioner">
                                          Commission:
                                        </td>
                                        <td></td>
                                        <td className="text-right">
                                          {(
                                            orderedPrescription[0]
                                              ?.Commission_Price / 100
                                          ).toLocaleString("en-US", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2,
                                            style: "currency",
                                            currency: "USD",
                                          })}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="total-practitioner">
                                          Preparation Cost:
                                        </td>
                                        <td></td>
                                        <td className="text-right">
                                          {(
                                            orderedPrescription[0]
                                              ?.Preparation_Price / 100
                                          ).toLocaleString("en-US", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2,
                                            style: "currency",
                                            currency: "USD",
                                          })}
                                        </td>
                                      </tr>
                                    </>
                                  )}
                                  <tr>
                                    <td className="total-practitioner">
                                      Total:
                                    </td>
                                    <td className="d-flex justify-content-end">
                                      <p className="hr-replacement">
                                        {orderedPrescription[0]?.Dosage_Type ===
                                        0
                                          ? (
                                              orderedPrescription[0]
                                                ?.Serving_Total * perPacket
                                            ).toLocaleString("en-US", {
                                              maximumFractionDigits: 1,
                                              minimumFractionDigits: 1,
                                            })
                                          : perPacket.toLocaleString("en-US", {
                                              maximumFractionDigits: 1,
                                              minimumFractionDigits: 1,
                                            })}
                                      </p>
                                    </td>
                                    {isOrdered && practitionerView && (
                                      <td className="text-right">
                                        <div className="d-flex justify-content-end">
                                          <p className="hr-replacement">
                                            {(
                                              orderedPrescription[0]
                                                ?.Total_Price / 100
                                            ).toLocaleString("en-US", {
                                              maximumFractionDigits: 2,
                                              minimumFractionDigits: 2,
                                              style: "currency",
                                              currency: "USD",
                                            })}
                                          </p>
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                          {isSentToPatient && (
                            <div className="sent-info">
                              <p>
                                Patient has not purchased prescription yet.
                                Total Price and Commission will be determined
                                once patient completes purchase.
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="serving-section">
                          {orderedPrescription[0]?.Serving_Amount == 0 ||
                          orderedPrescription[0]?.Serving_Per_Day == 0 ||
                          orderedPrescription[0]?.Serving_Days == 0 ? (
                            ""
                          ) : (
                            <>
                              <h3>Serving instructions</h3>
                              {orderedPrescription[0]?.Dosage_Type === 0 ? (
                                <p>
                                  {orderedPrescription[0]?.Serving_Per_Day}{" "}
                                  packet(s) a day for{" "}
                                  {orderedPrescription[0]?.Serving_Days} day(s)
                                </p>
                              ) : (
                                <p>
                                  {orderedPrescription[0]?.Serving_Amount}{" "}
                                  {orderedPrescription[0]?.Prep_Method == 5
                                    ? " capsule(s) "
                                    : orderedPrescription[0]?.Prep_Method == 1
                                    ? " scoop(s) "
                                    : orderedPrescription[0]?.Prep_Method == 6
                                    ? " tablet(s) "
                                    : "scoop(s) "}
                                  {orderedPrescription[0]?.Serving_Per_Day}{" "}
                                  times a day(s) for{" "}
                                  {orderedPrescription[0]?.Serving_Days} day(s)
                                </p>
                              )}
                            </>
                          )}
                          {practitionerView && (
                            <>
                              <h3 className="mt-2">Notes on Prescription</h3>
                              <p>
                                {!orderedPrescription[0]?.Patient_Instruct
                                  ? "None"
                                  : orderedPrescription[0]?.Patient_Instruct}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="btn-section">
                      <div className="d-flex justify-content-between">
                        <div>
                          <ReactToPrint
                            trigger={() => (
                              <button className="btn-orange">PRINT</button>
                            )}
                            content={() => componentRef.current}
                          />
                        </div>
                        <div className="d-flex">
                          {orderedPrescription[0]?.Patient_Name ? (
                            <>
                              <div>
                                <button
                                  style={{ marginRight: "20px" }}
                                  disabled={appLoading}
                                  className="btn-orange"
                                  onClick={() => rePrescribe()}
                                >
                                  Represcribe
                                </button>
                              </div>
                            </>
                          ) : (
                            <div className="d-flex justify-content-between">
                              <div style={{ marginRight: "20px" }}>
                                <select
                                  className="filter-select"
                                  onChange={(e) => {
                                    setSelectedPatient(
                                      parseInt(e.target.value)
                                    );
                                  }}
                                >
                                  <option value={0}> Select A Patient</option>
                                  {getPatientOptions()}
                                </select>
                              </div>
                              <div onClick={() => handleAssign()}>
                                <button
                                  disabled={selectedPatient === 0}
                                  className="btn-orange"
                                >
                                  Assign
                                </button>
                              </div>
                            </div>
                          )}
                          {isRefill && (
                            <div onClick={() => denyPrescription()}>
                              <button className="btn-orange">Deny</button>
                            </div>
                          )}
                        </div>
                      </div>
                      {!orderedPrescription[0]?.Patient_Name && (
                        <div
                          className="d-flex justify-content-center mt-2"
                          style={{ color: "white", fontSize: "13px" }}
                        >
                          <p className="desc">
                            The prescription was made with the previous version
                            of the software. Please Assign it to a patient on
                            your list before represcribing.
                          </p>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </>
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};
export default PractitionerPrescriptionDetailPopup;
